<template>
  <v-container fluid class="subpage-slider-container">
    <v-row no-gutters class="slider">
      <v-col cols="12" class="slider-inside-container">
        <div class="slider-textbox" :style="title_style">
          <slot></slot>
        </div>
        <img :src="overlay_image" :style="overlay_style" class="overlay-image"/>
        <v-img v-if="!is_multiple" :src="image" class="slider-image"/>
        <img v-else :src="image" class="slider-image-is-multiple" :style="image_style" />
      </v-col>
    </v-row>
    <v-row justify="center" style="background-color: #FFF;">
      <div class="grey-bar">
        <v-breadcrumbs :items="breadcrumbs" divider=">>"/>
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'SubpageSlider',
  props: ['image', 'overlay_image', 'overlay_style', 'is_multiple', 'title_style', 'article_title', 'image_style', 'is_trianon'],
  data() {
    return {
      breadcrumbs: [],
    };
  },
  mounted() {
    const homepage = this.$router.options.routes.find((route) => route.path === '/');
    this.breadcrumbs.push({
      text: homepage.name,
      href: homepage.path,
    });
    if (this.$props.is_trianon) {
      this.breadcrumbs.push({
        text: 'Virtuális kiállítások',
        href: '/#/virtualis-kiallitasok',
      });
      this.breadcrumbs.push({
        text: 'Trianon árvái',
        href: '/#/virtualis-kiallitasok/trianoni-arvak',
      });
      if (this.$route.params.slug) {
        this.breadcrumbs.push({
          text: this.$props.article_title,
          href: `/#/virtualis-kiallitasok/trianoni-arvak/${this.$route.params.slug}`,
        });
      }
    } else if (this.$route.params.slug) {
      this.breadcrumbs.push({
        text: this.$route.name,
        href: `/#${this.generatePath()}`,
      });
      this.breadcrumbs.push({
        text: this.$props.article_title,
        href: this.$route.path,
      });
    } else {
      this.breadcrumbs.push({
        text: this.$route.name,
        href: `/#${this.$route.path}`,
      });
    }
  },
  methods: {
    generatePath() {
      return this.$route.path.match('\\/([A-z]|[0-9]|-)*(?=\\/)')[0];
    },
  },
};
</script>

<style scoped>

</style>
